
export default {
  props: ['plans'],
  data() {
    return {
      levels: [
        {
          title: "توسعه‌دهندگان",
          cap: "اگر در حال آزمایش و توسعه اولیه محصول هستید و کافیست در ساعات کاری پشتیبانی فنی دریافت کنید، پشتیبانی پایه برای شما مناسب است.",
          items: ["پشتیبانی در ساعات اداری", "نصب و راه‌اندازی سرویس"],
        },
        {
          title: "استارتاپ‌ها",
          cap: "چنانچه درگیر رشد استارتاپ خود هستید و می‌خواهید درساعات اداری به پشتیبانی فنی و راهنمایی‌های معماری دسترسی داشته باشید، پشتیبانی پلن پیشرفته گزینه ایده‌آلی برای شماست.",
          items: [
            "پشتیبانی 24*7*365",
            "نصب و راه‌اندازی سرویس",
            "مشاوره تخصصی",
          ],
        },
        {
          title: "کسب و کارها",
          cap: "در صورتی که بارهای کاری حیاتی‌ای دارید و علاوه بر پشتیبانی تخصصی، در نصب و نگهداری سرویس به همراهی نیاز دارید، این پکیج با نیاز شما سازگاری بالایی دارد.",
          items: [
            "پشتیبانی 24*7*365",
            "نصب و راه‌اندازی سرویس",
            "مشاوره تخصصی",
            "نگهداری سرویس راه‌اندازی شده",
            "مشاوره مهاجرت ابری",
          ],
        },
        {
          title: "سازمان های بزرگ",
          cap: "در این پکیج علاوه بر ارائه تخصصی‌ترین پشتیبانی و مانیتورینگ پویا، یکی از نیروهای متخصص ما در نقش اکانت‌منیجر فنی همراه سازمان شما خواهد بود.",
          items: [
            "پشتیبانی 24*7*365",
            "نصب و راه‌اندازی سرویس",
            "مشاوره تخصصی",
            "نگهداری سرویس راه‌اندازی شده",
            "مشاوره مهاجرت ابری",
            "Proactive monitoring",
            "Technical Account Manager",
          ],
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    goToVps() {},
    handleScroll(index) {
      let perviuos = this.activeTab;
      this.activeTab = index;
      const element = document.getElementById(`cards`);

      if (index+1 > perviuos) {
        element.scrollLeft -= (index + 1) * 100;
      } else {
        element.scrollLeft += (index + 1) * 100;
      }
    },
  },
};
